import { styled, Typography } from '@mui/material';

const Holder = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.paper.light,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  
  position: 'relative',
}));

const ContentHolder = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  position: 'relative',
}));

interface Props {
  title: string;
  children: React.ReactNode;
}
export const WhiteHolder = ({ title, children }: Props) => (
  <Holder>
    <Typography variant="subtitle2" color="text.primary">
      {title}
    </Typography>
    <ContentHolder>{children}</ContentHolder>
  </Holder>
);
